<template>
    <b-modal id="modal_form"
         ref="modal_form"
         :title="modal_titulo"
         :ok-title="modal_botao"
         close-title="Fechar"
         cancel-title="Cancelar"
         :ok-disabled=form.errors.any()
         v-model="showModal"
         @ok="handleOk">

<form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
 <div v-if="this.modal_acao == 'u'">
   <label>Código</label>
   <b-form-input type="text"
                 placeholder="Código"
                 v-model="form.cd"
                 name="cd"
                 >
   </b-form-input>
   <b-form-feedback v-text="form.errors.get('cd')" v-if="form.errors.has('cd')"></b-form-feedback>
 </div>

   <label>Apólice</label>
   <b-form-input type="text"
                 placeholder="Apólice"
                 v-model="form.apolice"
                 name="apolice"
                 >
   </b-form-input>
   <b-form-feedback v-text="form.errors.get('apolice')" v-if="form.errors.has('apolice')"></b-form-feedback>

   <label>Nome</label>
   <b-form-input type="text"
                 placeholder="Nome"
                 v-model="form.nome"
                 name="nome"
                 >
   </b-form-input>
   <b-form-feedback v-text="form.errors.get('nome')" v-if="form.errors.has('nome')"></b-form-feedback>

     <label>Pessoa Juridica</label>
     <multiselect v-model="pessoaSelected"
     :options-limit="300"
     :limit="3"
     :limit-text="limitText"
     :options="optionsPessoa"
     track-by="value"
     label="label"
     :hide-selected="true"
     placeholder="Cliente ( Digite ao menos 3 caracteres, CNPJ, Código, IE ou Razão Social )"
     tag-placeholder="Selecionar"
     select-label="Selecionar"
     selected-label="Selecionado"
     deselect-label="Remover"
     :searchable="true"
     :loading="isLoadingPessoa"
     @search-change="listaPessoa"
     ></multiselect>
     <b-form-feedback class="text-danger" v-text="form.errors.get('pessoa.value')" v-if="form.errors.has('pessoa.value')"></b-form-feedback>

   <label>Status</label>
   <multiselect v-model="statusSelected"
   :options="optionsLivStatus"
   track-by="value"
   label="label"
   :hide-selected="true"
   placeholder="Selecione"
   tag-placeholder="Selecionar"
   select-label="Selecionar"
   selected-label="Selecionado"
   deselect-label="Remover"
   ></multiselect>
   <b-form-feedback v-text="form.errors.get('status.value')" v-if="form.errors.has('status.value')"></b-form-feedback>

   <label>Envia CTE por email</label>
   <multiselect v-model="enviaEmailSelected"
   :options="optionsLivEnviaEmail"
   track-by="value"
   label="label"
   :hide-selected="true"
   placeholder="Selecione"
   tag-placeholder="Selecionar"
   select-label="Selecionar"
   selected-label="Selecionado"
   deselect-label="Remover"
   ></multiselect>
   <b-form-feedback v-text="form.errors.get('envia_email.value')" v-if="form.errors.has('envia_email.value')"></b-form-feedback>

   <label>E-mail</label>
   <b-form-input type="email"
                 placeholder="Email"
                 v-model="form.email"
                 name="email"
                 >
   </b-form-input>
   <b-form-feedback v-text="form.errors.get('email')" v-if="form.errors.has('email')"></b-form-feedback>

</form>
      <div slot="modal-footer" class="w-100">
             <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
             <div class="float-right">
                 <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
                 <b-btn @click="showModal=false" variant="secondary">
                   Fechar
                 </b-btn>
                 <b-btn @click="handleOk($event)" variant="secondary" :disabled="isDisabled">
                   Enviar
                 </b-btn>
             </div>
      </div>
  </b-modal>
</template>
<script>
import { formatCNPJFromParts } from "../utils";

import AvisoErros from '../components/AvisoErros'

export default {
components: {
    AvisoErros,
},
props: {
    metodo: {type: Function},
    tabela: '',
    rota: ''
},
data () {
    return {
        modal_titulo: '',
        modal_botao: '',
        modal_acao: '',
        loading: false,
        isDisabled: false,
        loadingData: true,
        showModal: false,
        showModalGrupo: false,
        isFullscreen: false,
        isLoadingPessoa: false,
        optionsLivStatus: [],
        optionsLivEnviaEmail: [],
        optionsPessoa: [],
        statusSelected: [],
        pessoaSelected: [],
        enviaEmailSelected: [],
        errors_array: [],
        helpForm: new Form({
            statusRecord: [],
            params: [],
            search: ''
        }),
        form: new Form({
           cd: '',
           nome: '',
           segurado_id: '',
           apolice: '',
           envia_email: '',
           email: '',
           pessoa_id: '',
           status: ''

        }),
        fields: [],
      css: {
          loadingClass: 'loading',
          ascendingIcon: 'glyphicon glyphicon-chevron-up',
          descendingIcon: 'glyphicon glyphicon-chevron-down',
          handleIcon: 'glyphicon glyphicon-menu-hamburger',
      },
      moreParams: {}
   }
},
watch: {
    statusSelected(obj) {
        this.form.status = obj.value;
    },
    pessoaSelected(obj) {
        this.form.pessoa_id = obj.value;
    },
    enviaEmailSelected(obj) {
        this.form.envia_email = obj.value;
    }
},
mounted() {
    this.getLivGeral();
  },
methods: {
    handleOk(e)
    {
        e.preventDefault();
        if(this.modal_acao=="i")
        {
           this.onStore();
        }
        else
        {
            this.onUpdate(this.form.segurado_id);
        }
    },
    onCreate() {
        this.isDisabled = false;
        this.loading = false;
        this.modal_titulo = "Cadastrar";
        this.modal_botao = "Cadastrar";
        this.modal_acao = "i";
        this.form.reset();
        this.errors_array = '';
        this.errors_array = [];
        this.statusSelected = [];
        this.pessoaSelected = [];
        this.enviaEmailSelected = [];
        this.$refs.modal_form.show();
    },
    onEdit(data, index, id) {
        this.isDisabled = false;
        this.loading = false;
        this.modal_titulo = "Alterar";
        this.modal_botao = "Alterar";
        this.modal_acao = "u";
        this.form.reset();
        this.errors_array = '';
        this.errors_array = [];
        this.statusSelected = [];
        this.pessoaSelected = [];
        this.enviaEmailSelected = [];
        this.form.cd = data.cd;
        this.form.apolice = data.apolice;
        this.form.nome = data.nome;
        this.form.email = data.email;
        if(data.pessoa!==null)
        {
            this.pessoaSelected = { label: data.pessoa.pessoa_juridica.razao_social, value: data.pessoa.pessoa_id };
        }
        this.statusSelected= { label: data.status.descr, value: data.status.valor };
        this.enviaEmailSelected = { label: data.envia_email.descr, value: data.envia_email.valor };
        this.form.segurado_id = id;
        this.$refs.modal_form.show();
    },
    onStore()
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.put('/api/'+this.rota+'/store').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    onUpdate(id)
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.patch('/api/'+this.rota+'/update/'+id).then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    onActivateDesactivate(helpForm)
    {
        helpForm.patch('/api/'+this.rota+'/status').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });

    },
    getLivGeral()
    {
        this.helpForm.get('/api/seguradora/jsonlistgeral').then(response =>
        {
            new ReturnApi(response, this, true, false, false);
            response.status.forEach((obj)=>
            {
                this.optionsLivStatus.push({ label: obj.descr, value: obj.valor })
            })
            response.envia_email.forEach((obj)=>
            {
                this.optionsLivEnviaEmail.push({ label: obj.descr, value: obj.valor })
            })
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    limitText (count) {
      return ' e ${count} outros clientes'
    },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
    },
    listaPessoa(search) {
        if(search.length>=3)
        {
            this.isLoadingPessoa = true;
            this.helpForm.search = search;
            this.helpForm.post('/api/pessoa/jsonlist').then(response =>
            {
                this.optionsPessoa = [];
                new ReturnApi(response, this, true, false, false);
                response.items.forEach((obj)=>
                {
                    this.optionsPessoa.push({ label: "PJ"+" - "+obj.pessoa.cd+" - "+obj.razao_social+" - "+this.onFormataCnpj(obj.cnpj_base,obj.cnpj_filial,obj.cnpj_digito), value: obj.pessoa_id })
                });

                this.isLoadingPessoa = false;
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this, true, null, null, false);
                this.errors_array = '';
                this.errors_array = [];
                for (var property in errors) {
                  if (errors.hasOwnProperty(property)) {
                    if (typeof(errors[property]) === 'object') {
                      errors[property].forEach((obj) => {
                        this.errors_array.push({
                          erro: obj
                        });
                      });
                    }
                  }
                }
              });
          }
    },

    onError(response) {
        new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
        return this.getPermissionFw(checkPermission);
    },
},
computed: {
    vuetableFilterRow: {
      get () {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
        get() {
            return this.$store.getters.isloaded;
        }
    }
}
}
</script>